import React from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import Button from '../../../components/Common/Button';
import CardItem from '../../../components/Exchange/Category/CardItem';
import List from '../../../components/Exchange/Common/ListLayout';
import * as actions from "../../../store/action/exchange";
import common from '../../../common/common';
import { categoryMap } from '../../../common/category';
import exchange from '../../../common/exchange';
import { Commun } from "../../../utils/axios";
import styles from './index.module.scss';

class Module extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false, // 是否正在加载列表
            data: [] // 列表数据
        }
    }

    static defaultProps = {
        category: categoryMap['avatar']
    };

    static propTypes = {
        category: PropTypes.number, // 兑换类型 1-头像框  2-弹幕框  3-视频框  4-实物奖励
    };

    componentDidMount() {
        this.getList();
    }

    componentDidUpdate(prevProps, prevState) {
        const { category, organization } = this.props;
        if (category !== prevProps.category || organization !== prevProps.organization) {
            this.setState({
                data: []
            });
            this.getList();
        }
    }

    // 获取兑换列表
    getList = () => {
        const { category, organization } = this.props;

        if (organization === undefined) return;

        this.setState({
            loading: true
        });
        Commun.get(`${common.starApiPrefix}/good/list`, {
            categoryId: category,
            organizationId: organization
        }).then(res => {
            this.setState({
                data: res.list
            });
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            this.setState({
                loading: false
            });
        });
    };

    /**
     * 点击兑换
     * @param productInfo {Object} 商品信息
     */
    onExchange = (productInfo = {}) => {
        console.log('点击兑换', productInfo, window.history.length);
        exchange.onExchange({
            productIds: [productInfo.itemId],
            studentInfo: this.props.studentInfo,
            onComplete: this.getList
        })
    };

    // 获取Card内容
    getContent = (item) => {
        const isGift = item.categoryId === categoryMap['gift']; // 是否是实物奖励

        let hoverContent;
        if (!item.itemStock) {
            // 已售罄
            hoverContent = <p className={styles.soldOut}>{intl.get('SOLD_OUT_TIPS')}</p>
        } else if (!isGift && item.purchased && item.permanent) {
            // 虚拟奖品 && 已永久拥有使用权
            hoverContent = <p>{intl.get('NO_EXCHANGE')}</p>
        } else {
            // 立即兑换按钮
            hoverContent = (
                <div className={styles.exchangeBtn}>
                    <Button type="primary" onClick={() => this.onExchange(item)}>{intl.get('EXCHANGE')}</Button>
                </div>
            )
        }

        return <CardItem
            cover={item.imageUrl}
            title={item.itemName}
            showValidTerm={!isGift}
            validTerm={item.validTerm}
            stock={item.itemStock}
            unlimitedStock={item.unlimitedStock}
            starValue={item.starValue}
            showLabel={item.purchased}
            hoverContent={hoverContent}
        />
    };


    render() {
        const { category } = this.props;
        const {
            loading,
            data
        } = this.state;

        let listColumns = common.isPhone() ? 2 : 3, // 一行展示几列
            listClassName = '';  // 类名
        switch(category) {
            case categoryMap['avatar']:
                // 头像框
                listClassName = styles.avatarList;
                break;
            case categoryMap['subtitles']:
                // 弹幕框
                listClassName = styles.subtitlesList;
                break;
            case categoryMap['video']:
                // 视频框
                listClassName = styles.videoList;
                break;
            case categoryMap['gift']:
                // 实物奖励
                listClassName = styles.giftList;
                break;
        }

        return (
            <List
                className={listClassName}
                loading={loading}
                columns={listColumns}
                data={data}
                getContent={this.getContent}
            />
        )
    }
}

const mapStateToProps = state => ({
    ...state.exchange
});

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Module));